import generateID from '../generateID';
import { isSpectraData1D } from './isSpectraData1D';
export function checkIDs(input = []) {
    let inputClone = JSON.parse(JSON.stringify(input));
    let spectra = [];
    for (const spectraData of inputClone) {
        if (!('info' in spectraData)) {
            throw new Error('each spectrum should contain info properties with nucleus information');
        }
        const { info, id } = spectraData;
        if (isSpectraData1D(spectraData)) {
            let ranges = addIDs(spectraData.ranges);
            spectra.push({ id, info, ranges });
        }
        else {
            let data = addIDs(spectraData.zones);
            spectra.push({ id, info, zones: data });
        }
    }
    return spectra;
}
export function hasIDs(data) {
    for (const element of data) {
        if (!element.id)
            throw new Error('A range/zone has not an ID');
        for (let signal of element.signals || []) {
            if (!signal.id)
                throw new Error('A signal has not an ID');
        }
    }
}
export function addIDs(data) {
    for (const element of data) {
        if (!element.id)
            element.id = generateID();
        for (let signal of element.signals || []) {
            if (!signal.id)
                signal.id = generateID();
        }
    }
    hasIDs(data);
    return data;
}
//# sourceMappingURL=checkIDs.js.map